import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import api from '../services/api';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!newPassword || !confirmPassword) {
      toast.error('Заполните оба поля');
      return;
    }

    if (newPassword.length < 6) {
      toast.error('Пароль должен содержать минимум 6 символов');
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error('Пароли не совпадают');
      return;
    }

    try {
      setLoading(true);
      await api.resetPassword(token, newPassword);
      setSuccess(true);
    } catch (error) {
      toast.error(error.message || 'Ошибка при сбросе пароля. Ссылка могла устареть.');
      console.error('Reset password error:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="login-page">
        <div className="login-container">
          <div className="login-header">
            <h1>Иван Везёт</h1>
            <p>Админ панель</p>
          </div>
          <div style={{ textAlign: 'center' }}>
            <p style={{ color: '#ef4444', marginBottom: '1rem' }}>
              Недействительная ссылка для сброса пароля.
            </p>
            <button
              onClick={() => navigate('/login')}
              className="btn btn-primary btn-large"
              style={{ width: '100%' }}
            >
              Перейти к входу
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <h1>Иван Везёт</h1>
          <p>Админ панель</p>
        </div>

        {success ? (
          <div className="login-form" style={{ textAlign: 'center' }}>
            <p style={{
              color: '#16a34a',
              fontSize: '1rem',
              fontWeight: '500',
              marginBottom: '1rem'
            }}>
              Пароль успешно изменён
            </p>
            <p style={{
              color: '#64748b',
              fontSize: '0.875rem',
              marginBottom: '1.5rem'
            }}>
              Теперь вы можете войти с новым паролем.
            </p>
            <button
              onClick={() => navigate('/login')}
              className="btn btn-primary btn-large"
              style={{ width: '100%' }}
            >
              Перейти к входу
            </button>
          </div>
        ) : (
          <form className="login-form" onSubmit={handleSubmit}>
            <h3 style={{
              textAlign: 'center',
              marginBottom: '1.5rem',
              color: '#1e293b',
              fontSize: '1.125rem'
            }}>
              Установка нового пароля
            </h3>
            <div className="form-group">
              <label htmlFor="new-password">Новый пароль</label>
              <input
                id="new-password"
                type="password"
                required
                placeholder="Введите новый пароль"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                disabled={loading}
              />
            </div>
            <div className="form-group">
              <label htmlFor="confirm-password">Подтвердите пароль</label>
              <input
                id="confirm-password"
                type="password"
                required
                placeholder="Повторите пароль"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                disabled={loading}
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="btn btn-primary btn-large"
            >
              {loading ? (
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
              ) : (
                'Сменить пароль'
              )}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default ResetPassword;
